import { render, staticRenderFns } from "./messageBox.vue?vue&type=template&id=6472734c&scoped=true"
import script from "./messageBox.vue?vue&type=script&lang=js"
export * from "./messageBox.vue?vue&type=script&lang=js"
import style0 from "./messageBox.vue?vue&type=style&index=0&id=6472734c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472734c",
  null
  
)

export default component.exports